function chebyshevLP(pos_idxs, W, lb=-1, ub=1) {
    const n = W.length;
    let constraints = [];
    let bounds = [];
    const EPS = 1e-2;

    let ncols = 0;
    for (let i = 0; i < n; i++) {
        let row = W[i];
        ncols = W[i].length;
        let sum = 0;
        let constr = `c${i+1}: `;
        for (let j = 0; j < ncols; j++) {
            sum += Math.pow(row[j], 2);
            // sum += Math.abs(row[j]);
            if (pos_idxs.includes(i)) {
                constr += `${-row[j]} x${j+1} + `;
            }
            else {
                constr += `${row[j]} x${j+1} + `;
            }
        }
        let norm = Math.sqrt(sum);
        constr = constr.slice(0, -2);
        constr += `+ ${norm} r <= 0`;
        constraints.push(constr);
    }
    for (let j = 0; j < ncols; j++) {
        bounds.push(`${lb} <= x${j+1} <= ${ub}`);
    }
    bounds.push(`${EPS} <= r <= 10000`);

    const prob=`Maximize
    obj:
     r
    Subject To
     ${constraints.join('\n     ')}
    Bounds
     ${bounds.join('\n     ')}
    End`;
    return prob;
}

export default chebyshevLP;
